import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb990eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "navbar",
  role: "navigation",
  "aria-label": "Topbar Menu",
  class: "oxd-topbar-body-nav"
}
const _hoisted_2 = { class: "oxd-topbar-body-nav-slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_navigation_link = _resolveComponent("oxd-navigation-link")!
  const _component_oxd_navigation_more = _resolveComponent("oxd-navigation-more")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenuItems, (menuItem, index) => {
        return (_openBlock(), _createBlock(_component_oxd_navigation_link, {
          ref_for: true,
          ref: _ctx.setMenuItem,
          key: `nav-level1-${index + _ctx.width}`,
          "menu-item": menuItem,
          class: _normalizeClass(_ctx.menuClasses[index])
        }, null, 8, ["menu-item", "class"]))
      }), 128)),
      (_ctx.hiddenMenuItems.length > 0)
        ? (_openBlock(), _createBlock(_component_oxd_navigation_more, {
            key: 0,
            "menu-items": _ctx.hiddenMenuItems
          }, null, 8, ["menu-items"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ], 512))
}